(() => {
  const initializeDock = (dock) => {
    const sectionId = dock.dataset.productSection;
    const productInfo = document.getElementById(`ProductInfo-${sectionId}`);
    const sourceButton = productInfo?.querySelector('.product-form__submit');
    const dockButton = dock.querySelector('[data-bird-dock-add]');
    const dockPrice = dock.querySelector('[data-bird-dock-price]');
    const dockVariant = dock.querySelector('[data-bird-dock-variant]');
    const footer = document.querySelector('.shopify-section-group-footer-group, footer');
    let sourceVisible = true;
    let footerVisible = false;
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    if (!productInfo || !sourceButton || !dockButton) return;

    const updateVisibility = () => {
      const scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const passedScrollThreshold = scrollableHeight > 0 && window.scrollY / scrollableHeight >= 0.2;
      const visible = mobileQuery.matches && passedScrollThreshold && !sourceVisible && !footerVisible;
      dock.dataset.visible = String(visible);
      dock.inert = !visible;
      dock.setAttribute('aria-hidden', String(!visible));
      document.documentElement.classList.toggle('bird-product-dock-is-visible', visible);
    };

    let visibilityFrame = null;
    const scheduleVisibility = () => {
      if (visibilityFrame !== null) return;
      visibilityFrame = window.requestAnimationFrame(() => {
        visibilityFrame = null;
        updateVisibility();
      });
    };
    window.addEventListener('scroll', scheduleVisibility, { passive: true });
    window.addEventListener('resize', scheduleVisibility, { passive: true });
    window.addEventListener('pageshow', scheduleVisibility);
    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleVisibility).observe(document.body);
    }

    const updateDock = () => {
      const selectedValues = [...productInfo.querySelectorAll('variant-selects [data-selected-value]')]
        .map((value) => value.textContent.trim())
        .filter(Boolean);
      const salePrice = productInfo.querySelector('.price-item--sale');
      const regularPrice = productInfo.querySelector('.price-item--regular');
      const currentPrice = salePrice?.textContent.trim() || regularPrice?.textContent.trim();

      if (dockVariant && selectedValues.length) dockVariant.textContent = selectedValues.join(' · ');
      if (dockPrice && currentPrice) dockPrice.textContent = currentPrice;
      dockButton.disabled = sourceButton.disabled;
      dockButton.textContent = sourceButton.disabled ? sourceButton.textContent.trim() : 'Add to cart';
    };

    const sourceObserver = new IntersectionObserver(
      ([entry]) => {
        sourceVisible = entry.isIntersecting && entry.intersectionRatio >= 0.99;
        updateVisibility();
      },
      { threshold: [0, 0.99, 1] }
    );

    sourceObserver.observe(sourceButton);
    mobileQuery.addEventListener('change', updateVisibility);
    updateVisibility();
    if (footer) {
      new IntersectionObserver(
        ([entry]) => {
          footerVisible = entry.isIntersecting;
          updateVisibility();
        },
        { threshold: 0.01 }
      ).observe(footer);
    }
    productInfo.addEventListener('change', () => window.setTimeout(updateDock, 0));
    new MutationObserver(updateDock).observe(productInfo, { childList: true, subtree: true, characterData: true });
    dockButton.addEventListener('click', () => sourceButton.click());
    updateDock();
  };

  const initialize = () => {
    document.querySelectorAll('[data-bird-product-dock]').forEach(initializeDock);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
